var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import SwimpoolCoverPanelMaterials from './SwimpoolCover/SwimpoolCoverPanelMaterials.vue';
import SwimpoolCoverPanels from './SwimpoolCover/SwimpoolCoverPanels.vue';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
import { VerandaPanelGlazingType, VerandaPanelMaterial, } from '@shared/types/api/externalDamage';
let SwimpoolCover = class SwimpoolCover extends ExternalDamageComponent {
    get panels() {
        var _a;
        return ((_a = this.externalDamage.panels) !== null && _a !== void 0 ? _a : []);
    }
    get selectedMaterials() {
        return Object.values(VerandaPanelMaterial).filter((material) => this.panels.some((panel) => (panel === null || panel === void 0 ? void 0 : panel.material) === material));
    }
    set selectedMaterials(materials) {
        if (!materials.includes(VerandaPanelMaterial.Glass)) {
            this.glassPanelCount = 0;
        }
        else {
            this.glassPanelCount || (this.glassPanelCount = 1);
        }
        if (!materials.includes(VerandaPanelMaterial.Polycarbonate)) {
            this.polycarbonatePanelCount = 0;
        }
        else {
            this.polycarbonatePanelCount || (this.polycarbonatePanelCount = 1);
        }
        if (!materials.includes(VerandaPanelMaterial.SandwichPanel)) {
            this.sandwichPanelCount = 0;
        }
        else {
            this.sandwichPanelCount || (this.sandwichPanelCount = 1);
        }
        if (!materials.includes(VerandaPanelMaterial.Other)) {
            this.otherPanelCount = 0;
        }
        else {
            this.otherPanelCount || (this.otherPanelCount = 1);
        }
    }
    get glassPanels() {
        return this.panels.filter((panel) => (panel === null || panel === void 0 ? void 0 : panel.material) === VerandaPanelMaterial.Glass);
    }
    get polycarbonatePanels() {
        return this.panels.filter((panel) => (panel === null || panel === void 0 ? void 0 : panel.material) === VerandaPanelMaterial.Polycarbonate);
    }
    get sandwichPanels() {
        return this.panels.filter((panel) => (panel === null || panel === void 0 ? void 0 : panel.material) === VerandaPanelMaterial.SandwichPanel);
    }
    get otherPanels() {
        return this.panels.filter((panel) => (panel === null || panel === void 0 ? void 0 : panel.material) === VerandaPanelMaterial.Other);
    }
    get glassPanelCount() {
        return this.glassPanels.length;
    }
    set glassPanelCount(count) {
        var _a, _b;
        const diff = count - this.glassPanelCount;
        if (diff === 0)
            return;
        const panels = this.panels.slice();
        const materialPanels = this.glassPanels.slice();
        for (let i = 0; i < Math.abs(diff); i++) {
            if (diff > 0) {
                panels.push({
                    material: VerandaPanelMaterial.Glass,
                    glazingType: (_b = (_a = this.glassPanels.find((panel) => panel === null || panel === void 0 ? void 0 : panel.glazingType)) === null || _a === void 0 ? void 0 : _a.glazingType) !== null && _b !== void 0 ? _b : VerandaPanelGlazingType.Unknown,
                });
            }
            else {
                const panel = materialPanels.pop();
                const realIndex = panels.indexOf(panel);
                if (realIndex !== -1)
                    panels.splice(realIndex, 1);
            }
        }
        this.updateExternalDamage({ panels });
    }
    get polycarbonatePanelCount() {
        return this.polycarbonatePanels.length;
    }
    set polycarbonatePanelCount(count) {
        this.updateMaterialPanelsCount(VerandaPanelMaterial.Polycarbonate, count, this.polycarbonatePanels);
    }
    get sandwichPanelCount() {
        return this.sandwichPanels.length;
    }
    set sandwichPanelCount(count) {
        this.updateMaterialPanelsCount(VerandaPanelMaterial.SandwichPanel, count, this.sandwichPanels);
    }
    get otherPanelCount() {
        return this.otherPanels.length;
    }
    set otherPanelCount(count) {
        this.updateMaterialPanelsCount(VerandaPanelMaterial.Other, count, this.otherPanels);
    }
    updateMaterialPanelsCount(material, count, currentPanels) {
        const diff = count - currentPanels.length;
        if (diff === 0)
            return;
        const panels = this.panels.slice();
        const materialPanels = currentPanels.slice();
        for (let i = 0; i < Math.abs(diff); i++) {
            if (diff > 0) {
                panels.push({ material, glazingType: null });
            }
            else {
                const panel = materialPanels.pop();
                const realIndex = panels.indexOf(panel);
                if (realIndex !== -1)
                    panels.splice(realIndex, 1);
            }
        }
        this.updateExternalDamage({ panels });
    }
    getPanelsCount(material) {
        switch (material) {
            case VerandaPanelMaterial.Glass:
                return this.glassPanelCount;
            case VerandaPanelMaterial.Polycarbonate:
                return this.polycarbonatePanelCount;
            case VerandaPanelMaterial.SandwichPanel:
                return this.sandwichPanelCount;
            case VerandaPanelMaterial.Other:
                return this.otherPanelCount;
        }
    }
    setPanelsCount(material, count) {
        switch (material) {
            case VerandaPanelMaterial.Glass:
                this.glassPanelCount = count;
                break;
            case VerandaPanelMaterial.Polycarbonate:
                this.polycarbonatePanelCount = count;
                break;
            case VerandaPanelMaterial.SandwichPanel:
                this.sandwichPanelCount = count;
                break;
            case VerandaPanelMaterial.Other:
                this.otherPanelCount = count;
                break;
        }
    }
};
SwimpoolCover = __decorate([
    Component({
        components: {
            SwimpoolCoverPanelMaterials,
            SwimpoolCoverPanels,
        },
    })
], SwimpoolCover);
export default SwimpoolCover;
